import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { Route, Switch, Redirect } from 'react-router-dom';
import DrawerLayout from '../Global/DrawerLayout';
import VideoSection from './pages/Videos';
import QnASection from './pages/QA';
import { VideosIcon, FAQIcon, TicketsIcon, TurtorialIcon, TaskIcon, FeatureIcon } from '../Global/Icons';
import { TopPlaceIcon, UpdateIcon, QnAIcon, PodcastsIcon, ImprovementIcon } from '../Global/Icons';
import Tickets from './pages/Tickets';
import { ComingSoonView } from '../coming-soon/view';
import axios from 'axios';

export default function Support() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [newVideosCount, setNewVideosCount] = useState(0);
  useEffect(() => {
    axios
      .get('/help/getNewVideosCount')
      .then((res) => {
        setNewVideosCount(res.data);
      })
      .catch((e) => {
        setNewVideosCount(0);
      });
  });
  const drawerContent = {
    sections: [
      {
        items: [
          {
            title: 'My Tickets',
            icon: <TicketsIcon />,
            selectedIcon: <TicketsIcon />,
            link: '/help/support',
          },
          {
            divider: true,
          },
          {
            title: `New videos`,
            badgeContent: newVideosCount,
            icon: <TopPlaceIcon />,
            selectedIcon: <TopPlaceIcon />,
            link: '/help/newVideos',
          },
          {
            title: 'All videos',
            icon: <VideosIcon />,
            selectedIcon: <VideosIcon />,
            link: '/help/videos',
          },
          {
            title: 'Application tutorials',
            icon: <TurtorialIcon />,
            selectedIcon: <TurtorialIcon />,
            link: '/help/tutorials',
          },
          {
            title: 'Use cases',
            icon: <TaskIcon style={{ color: 'inherit' }} />,
            selectedIcon: <TaskIcon style={{ color: 'inherit' }} />,
            link: '/help/useCases',
          },
          {
            title: 'Feature help',
            icon: <FeatureIcon />,
            selectedIcon: <FeatureIcon />,
            link: '/help/features',
          },
          {
            divider: true,
          },
          {
            title: 'Qhub updates',
            icon: <UpdateIcon />,
            selectedIcon: <UpdateIcon />,
            link: '/help/updates',
          },
          {
            title: 'Podcasts',
            icon: <PodcastsIcon />,
            selectedIcon: <PodcastsIcon />,
            link: '/help/podcasts',
          },
          { divider: true },
          {
            title: 'Q&A',
            icon: <QnAIcon />,
            selectedIcon: <QnAIcon />,
            link: '/help/qna',
          },
          { divider: true },
          {
            title: 'Improvement board - Coming soon',
            icon: <ImprovementIcon />,
            selectedIcon: <ImprovementIcon />,
            link: '/help/comingSoon',
          },
        ],
      },
    ],
    bottomItems: [],
  };

  const routes = [
    { path: '/help', component: VideoSection },
    { path: '/help/videos', component: VideoSection, version: 'all' },
    { path: '/help/tutorials', component: VideoSection, version: 'tutorials' },
    { path: '/help/useCases', component: VideoSection, version: 'useCases' },
    { path: '/help/features', component: VideoSection, version: 'features' },
    { path: '/help/newVideos', component: VideoSection, version: 'newVideos' },
    { path: '/help/updates', component: VideoSection, version: 'updates' },
    { path: '/help/podcasts', component: VideoSection, version: 'podcasts' },
    { path: '/help/qna', component: QnASection },
    { path: '/help/comingSoon', component: ComingSoonView, version: 'comingSoon' },
    { path: '/help/support', component: Tickets },
  ];
  return (
    <DrawerLayout title="Support" hub="support" icon={<FAQIcon />} drawerContent={drawerContent} fillHeight>
      <Switch>
        {routes.map((route, index) => (
          <Route key={index} exact path={route.path} render={() => <route.component version={route.version} />} />
        ))}
      </Switch>
    </DrawerLayout>
  );
}
